import React, { Component } from "react";
import { Layout, Button, Col, Row, Space, Typography, List, message, Card, Statistic } from "antd";

import { IconEye } from '../../../Widgets/Iconos';
import { RenderSolicitudCompra } from "../../../Utils";
//Modales
import ModalSolicitudDetalle from './ModalSolicitudDetalle';

const { Content } = Layout;
const { Text } = Typography
const axios = require('axios')
const moment = require('moment')

/**
 * @export
 * @class SolicitudesList
 * @extends {Component}
 * @description En esta vista se despliegan las solicitudes creadas por el cliente, estas representan ordenes de compra qu estan en proceso de aprobacion
 * para despues formalmente crear las ordenes de compra
 */
export default class SolicitudesList extends Component {


    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            solicitudes: [],
            page: 1,
            limit: 10,
            total: 0,
            filtroSearch: '',

        }
    }


    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        this.getSolicitudes();
    }



    /**
    * @method componentDidUpdate
    * @description Actualiza la consulta si se buscan datos
    */
    componentDidUpdate() {
        const filtro = this.state.filtroSearch;
        const propFiltro = this.props.search;

        if (filtro !== propFiltro && this.state.searching == true) {
            this.getSolicitudes();
        }
    }


    /**
     * @memberof SolicitudesList
     * @method getSolicitudes
     * @description Obtiene las solicitudes de compra del cliente, estas son las ordenes de compra que estan en proceso de aprobacion
     */
    getSolicitudes = (page = this.state.page) => {
        let search = this.props.search;

        this.setState({ loading: true })
        axios.get('/customer/solicitudes', {
            params: {
                page: page,
                limit: this.state.limit,
                search: search
            }
        }).then(({data}) => {
            console.log('response',data);
            this.setState({
                solicitudes: data.data,
                page: data.page,
                total: data.total,
                filtroSearch: search,

            })
        }).catch(error => {
            console.log("ERR, error", error)
            message.error(error?.response?.data?.message || 'Error al obtener la información de las Solicitudes')
        }).finally(() => this.setState({ loading: false }))
    }

    /**
    * @memberof IngresosList
    * @method   renderMonto
    * @description  Retorna el monto con el color correspondinte dependiendo del tipo de transaccion
    **/
    renderMonto = (tipo, monto) => {
        let colors = ['#000000', '#00FF19', '#FF0000'];
        return <Statistic value={monto} valueStyle={{ fontSize: '16px', fontWeight: 'bold', color: colors[tipo] }} prefix={'$'} />
    }

    render() {

        return (
            <>
                <Content>
                    <Row>
                        <Col span={24}>
                            <List
                                className="component-list"
                                itemLayout="horizontal"
                                dataSource={this.state.solicitudes}
                                pagination={{
                                    current: this.state.page,
                                    pageSize: this.state.limit,
                                    total: this.state.total,
                                    hideOnSinglePage: false,
                                    position: 'bottom',
                                    className: "flex-left",
                                    onChange: (page) => this.getSolicitudes(page)
                                }}
                                loading={this.state.loading}
                                header={<Row className="header-list width-100 pr-1 pl-1" >
                                    <Col xs={12} lg={2} className="center">
                                        <Text>Fecha</Text>
                                    </Col>
                                    <Col xs={12} lg={2} className="center">
                                        <Text>Folio</Text>
                                    </Col>
                                    <Col xs={12} lg={5} className="center">
                                        <Text>Producto</Text>
                                    </Col>
                                    <Col xs={12} lg={2} className="center">
                                        <Text>Cantidad</Text>
                                    </Col>
                                    <Col xs={12} lg={4} className="center">
                                        <Text>Monto</Text>
                                    </Col>
                                    <Col xs={12} lg={4} className="center">
                                        <Text>Centro Costo</Text>
                                    </Col>
                                    <Col xs={12} lg={2} className="center">
                                        <Text>Estado</Text>
                                    </Col>
                                    <Col xs={24} lg={3} className="center">
                                        <Text>Acciones</Text>
                                    </Col>
                                </Row>}
                                renderItem={item => (
                                    <List.Item className="component-list-item">
                                        <Card className="card-list">
                                            <div className={`badge-card tipo-${item.tipo}`}>
                                            </div>
                                            <Row className="width-100">
                                                <Col xs={12} lg={2} className="center">
                                                    <Text strong>{moment(item.createdAt).format('DD/MM/YYYY')}</Text>
                                                </Col>
                                                <Col xs={12} lg={2} className="center">
                                                    <Text >{item.folio ?? '-'}</Text>
                                                </Col>
                                                <Col xs={12} lg={5} className="center">
                                                    <Text className="text-gray">{item.inventario_producto?.np_cliente}</Text>
                                                </Col>
                                                <Col xs={12} lg={2} className="center">
                                                    <Text className="text-gray">{item?.cantidad_solicitada}</Text>
                                                </Col>
                                                <Col xs={12} lg={4} className="center">
                                                    <Text className="text-gray-dark">$ {item.total_compra?.toMoney(true)} MXN</Text>
                                                </Col>
                                                <Col xs={12} lg={4} className="flex-column">
                            
                                                    <Text className="text">{item.centro_costo.nombre}</Text>
                                                </Col>
                                                <Col xs={12} lg={2} className="center">
                                                    {RenderSolicitudCompra(item)}
                                                </Col>
                                                <Col xs={24} lg={3} className="center">
                                                    <Space>
                                                        <Button
                                                            style={{paddingTop: '9px'}}
                                                            icon={<IconEye />}
                                                            type="primary"
                                                            title="Editar"
                                                            onClick={() => this.setState({ solicitud_id: item._id, modalVisible: true })}
                                                        >
                                                        </Button>
                                                    </Space>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </List.Item>
                                )}
                            />

                        </Col>
                    </Row>
                </Content>
                <ModalSolicitudDetalle
                    visible={this.state.modalVisible}
                    solicitud_id={this.state.solicitud_id}
                    onClose={() => {
                        this.setState({ modalVisible: false, solicitud_id: null })
                        this.getSolicitudes();
                    }}
                />
                
            </>
        )
    }
}